import { FC, memo } from 'react';
import { Box } from '@material-ui/core';
import { colors, fontSizes } from 'Theme/Variables';
import { useCardType } from 'Hooks';
import classNames from 'classnames';

import './ActiveCardItem.scss';
import { CardMastersData } from 'Models';
import { IbanNormalize } from 'Utils';

type ActiveCardItemProps = {
  card?: CardMastersData;
};

const ActiveCardItem: FC<ActiveCardItemProps> = memo(({ card }) => {
  const { cardPath, cardColor, gradient } = useCardType(card?.ProductCode);

  const getCardClassName = () => {
    if (card?.ProductCode === 'IKP_IKR' || card?.ProductCode === 'IKP_STD') {
      return 'card-item__plus_std';
    }
    if (card?.ProductCode === 'IKP_ORC') {
      return 'card-item__plus_orc';
    }
    return 'card-item__active';
  };

  const getCardStyle = () => {
    if (gradient) {
      return { background: gradient };
    }
    return {};
  };

  return (
    <div id="activeCardItem">
      <div
        className={classNames(getCardClassName(), {
          'card-item__container': true,
        })}
        style={getCardStyle()}
      >
        <Box display="flex">
          <img src={cardPath} alt="" />
        </Box>
        <Box overflow="hidden" marginLeft={fontSizes.big} flex={1}>
          <Box fontSize={fontSizes.small} style={{ marginBottom: '3px', color: '#fff' }}>
            {card?.CardNickname || ''}
          </Box>
          {card?.MaskedCardNumber && (
            <Box fontSize={fontSizes.regularBig} fontWeight="bold" style={{ color: '#fff' }}>
              {IbanNormalize(card?.MaskedCardNumber?.toString())}
            </Box>
          )}
        </Box>
      </div>
    </div>
  );
});

export default ActiveCardItem;
